var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SelectionCriteriaView_instances, _SelectionCriteriaView_parentElement, _SelectionCriteriaView_mainElement, _SelectionCriteriaView_topOffset, _SelectionCriteriaView_modal, _SelectionCriteriaView_initModal, _SelectionCriteriaView_initMobileView;
import Emitter from '@resources/js/helpers/Emitter';
import Modal from '@resources/js/ui/Modal';
import { isMobile } from '@helpers/media';
const SELECTORS = {
    mainComponent: '.js-selection-criteria',
    button: '.js-btn-modal-selection',
};
class SelectionCriteriaView extends Emitter {
    constructor({ parentElement, topOffset }) {
        super();
        _SelectionCriteriaView_instances.add(this);
        _SelectionCriteriaView_parentElement.set(this, void 0);
        _SelectionCriteriaView_mainElement.set(this, null);
        _SelectionCriteriaView_topOffset.set(this, void 0);
        _SelectionCriteriaView_modal.set(this, null);
        __classPrivateFieldSet(this, _SelectionCriteriaView_parentElement, parentElement, "f");
        __classPrivateFieldSet(this, _SelectionCriteriaView_topOffset, topOffset, "f");
        __classPrivateFieldSet(this, _SelectionCriteriaView_mainElement, __classPrivateFieldGet(this, _SelectionCriteriaView_parentElement, "f").querySelector(SELECTORS.mainComponent), "f");
        if (!__classPrivateFieldGet(this, _SelectionCriteriaView_mainElement, "f"))
            return;
        __classPrivateFieldGet(this, _SelectionCriteriaView_instances, "m", _SelectionCriteriaView_initModal).call(this);
        if (isMobile())
            __classPrivateFieldGet(this, _SelectionCriteriaView_instances, "m", _SelectionCriteriaView_initMobileView).call(this);
    }
}
_SelectionCriteriaView_parentElement = new WeakMap(), _SelectionCriteriaView_mainElement = new WeakMap(), _SelectionCriteriaView_topOffset = new WeakMap(), _SelectionCriteriaView_modal = new WeakMap(), _SelectionCriteriaView_instances = new WeakSet(), _SelectionCriteriaView_initModal = function _SelectionCriteriaView_initModal() {
    __classPrivateFieldSet(this, _SelectionCriteriaView_modal, new Modal(__classPrivateFieldGet(this, _SelectionCriteriaView_mainElement, "f"), {
        trigger: __classPrivateFieldGet(this, _SelectionCriteriaView_parentElement, "f").querySelector(SELECTORS.button),
    }), "f");
}, _SelectionCriteriaView_initMobileView = function _SelectionCriteriaView_initMobileView() {
    const SHOW_EVENT = 'show';
    const HIDE_EVENT = 'hide';
    __classPrivateFieldGet(this, _SelectionCriteriaView_modal, "f").on(SHOW_EVENT, () => {
        __classPrivateFieldGet(this, _SelectionCriteriaView_mainElement, "f").style.top = __classPrivateFieldGet(this, _SelectionCriteriaView_topOffset, "f") + 'px';
        this.emit(SHOW_EVENT);
    });
    __classPrivateFieldGet(this, _SelectionCriteriaView_modal, "f").on(HIDE_EVENT, () => {
        __classPrivateFieldGet(this, _SelectionCriteriaView_mainElement, "f").style.top = '0px';
        this.emit(HIDE_EVENT);
    });
};
export default SelectionCriteriaView;
